const map = {
	"./PPMonumentExtended-Black.woff": 980,
	"./PPMonumentExtended-Black.woff2": 8846,
	"./PPMonumentExtended-Bold.woff": 1162,
	"./PPMonumentExtended-Bold.woff2": 9324,
	"./PPMonumentExtended-Regular.woff": 2255,
	"./PPMonumentExtended-Regular.woff2": 5967
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6685;